export default "__VITE_ASSET__3364f4bb__"